import React from 'react';
import { useFamilyContext } from '../../contexts/FamilyContext';
import ManagementCard from './ManagementCard';
import RecentActivityFeed from './RecentActivityFeed';

export default function ParentManageView() {
  const { 
    family, 
    kidAllowances, 
    allowanceJobs, 
    familyActivities,
    recsIdeas 
  } = useFamilyContext();

  // Calculate allowance stats
  const getAllowanceStats = () => {
    const activeJobs = allowanceJobs?.filter(job => 
      job.status === 'available' || job.status === 'in_progress'
    ).length || 0;
    
    const totalOwed = family?.kids?.reduce((total, kid) => {
      const allowance = kidAllowances[kid.id];
      return total + (allowance?.current_balance || 0);
    }, 0) || 0;

    return [
      { value: activeJobs, label: 'Active Jobs' },
      { value: `$${totalOwed.toFixed(2)}`, label: 'Total Owed' }
    ];
  };

  // Calculate activity stats
  const getActivityStats = () => {
    const totalActivities = Object.values(kidAllowances).reduce((total, kidActivities) => {
      return total + (Array.isArray(kidActivities) ? kidActivities.length : 0);
    }, 0);

    // For now, using a placeholder rating - you could calculate actual average
    return [
      { value: totalActivities || 23, label: 'Activities' },
      { value: '4.2', label: 'Avg Rating' }
    ];
  };

  // Calculate ideas stats
  const getIdeasStats = () => {
    const newIdeas = recsIdeas?.filter(idea => 
      idea.status === 'new' || !idea.status
    ).length || 8;
    
    const categories = new Set(recsIdeas?.map(idea => idea.category) || []).size || 3;

    return [
      { value: newIdeas, label: 'New Ideas' },
      { value: categories, label: 'Categories' }
    ];
  };

  const managementAreas = [
    {
      icon: '💰',
      title: 'Allowance & Jobs',
      description: 'Manage weekly allowances and create earning opportunities for kids',
      colorScheme: 'allowance',
      stats: getAllowanceStats(),
      actions: [
        { label: 'Quick Transaction', onClick: () => {} },
        { label: 'Manage All', onClick: () => {}, primary: true }
      ],
      to: '/allowance'
    },
    {
      icon: '🎯',
      title: 'Activity Library',
      description: 'Browse and manage family activities by energy level and category',
      colorScheme: 'activities',
      stats: getActivityStats(),
      actions: [
        { label: 'Add Activity', onClick: () => {} },
        { label: 'Browse All', onClick: () => {}, primary: true }
      ],
              to: '/tasks?tab=activities'
    },
    {
      icon: '💡',
      title: 'Ideas & Opportunities',
      description: 'Curated suggestions for family activities, learning, and experiences',
      colorScheme: 'ideas',
      stats: getIdeasStats(),
      badgeCount: 4,
      badgeType: 'new',
      hasUpdates: true,
      actions: [
        { label: 'Suggest Idea', onClick: () => {} },
        { label: 'Explore All', onClick: () => {}, primary: true }
      ],
      to: '/ideas-opportunities'
    },
    {
      icon: '⚙️',
      title: 'App Settings',
      description: 'Family preferences, notifications, and account management',
      colorScheme: 'settings',
      actions: [
        { label: 'Open Settings', onClick: () => {}, primary: true }
      ],
      to: '/settings'
    }
  ];

  return (
    <div className="parent-manage-view">
      <div className="management-grid">
        {managementAreas.map((area, index) => (
          <ManagementCard key={index} {...area} />
        ))}
      </div>
      
      <RecentActivityFeed />
    </div>
  );
}